module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Mes projets > " + _vm._s(_vm.project.name))]), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dl', [_c('dt', [_vm._v("nom du projet")]), _c('dd', [_vm._v(_vm._s(_vm.project.name))]), _c('dt', [_vm._v("lien vers l'application")]), _c('dd', [_c('router-link', {
    attrs: {
      "to": {
        name: 'execute',
        params: {
          projectId: _vm.project.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.name))])], 1), _c('dt', [_vm._v("public")]), _c('dd', [_vm._v(_vm._s(_vm.project.isPublic ? 'oui' : 'non'))]), _c('dt', [_vm._v("largeur de la scène")]), _c('dd', [_vm._v(_vm._s(_vm.project.sceneWidth))]), _c('dt', [_vm._v("hauteur de la scène")]), _c('dd', [_vm._v(_vm._s(_vm.project.sceneHeight))]), _c('dt', [_vm._v("description")]), _c('dd', [_vm._v(_vm._s(_vm.project.description))]), _c('dt', [_vm._v("instructions")]), _c('dd', [_vm._v(_vm._s(_vm.project.instructions))])])]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('showView', {
          view: 'ProjectEditor',
          params: {
            project: _vm.project
          }
        })
      }
    }
  }, [_vm._v("modifier les informations")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAsCurrentProject
    }
  }, [_vm._v("travailler sur ce projet")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.project.isDefault),
      expression: "!project.isDefault"
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteProject
    }
  }, [_vm._v("supprimer")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f328604!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create/ProjectDetails.vue
// module id = 600
// module chunks = 2